import React from 'react';
import { Phone } from 'lucide-react';
type CaseResult = {
  amount: string;
  caseType: string;
  location: string;
  exposure: string;
};
const caseResults: CaseResult[] = [{
  amount: '$32.5M',
  caseType: 'Mesothelioma',
  location: 'California',
  exposure: 'Shipyard'
}, {
  amount: '$18.2M',
  caseType: 'Mesothelioma',
  location: 'Los Angeles',
  exposure: 'Construction'
}, {
  amount: '$12.4M',
  caseType: 'Wrongful Death',
  location: 'San Diego',
  exposure: 'U.S. Navy'
}, {
  amount: '$8.9M',
  caseType: 'Mesothelioma',
  location: 'Northern CA',
  exposure: 'Auto mechanic'
}, {
  amount: '$7.6M',
  caseType: 'Mesothelioma',
  location: 'Bay Area',
  exposure: 'Oil refinery'
}, {
  amount: '$6.3M',
  caseType: 'Wrongful Death',
  location: 'Long Beach',
  exposure: 'Dockworker'
}, {
  amount: '$5.1M',
  caseType: 'Lung Cancer',
  location: 'Fontana',
  exposure: 'Steel mill'
}, {
  amount: '$4.4M',
  caseType: 'Mesothelioma',
  location: 'Sacramento',
  exposure: 'Take-home'
}];
export function Results() {
  return <section id="results" className="py-20 md:py-24 bg-slate-50 border-y border-slate-200" data-id="element-248" data-mp="1r2e4zclj0xz2">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-249" data-mp="1w3bnjqag7u13">
        <div className="max-w-3xl mb-14" data-id="element-250" data-mp="2113dwfvg3836">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-900 mb-4" data-id="element-251" data-mp="20xz3h0rdzg42">
            Our California Asbestos Case Results
          </h2>
          <p className="text-lg text-slate-600 leading-relaxed" data-id="element-252" data-mp="29zp48x75rrei">
            We have secured some of the largest mesothelioma verdicts and
            settlements in California history, for workers and families across
            the state.
          </p>
        </div>

        <div className="bg-white border border-slate-200 rounded-xl overflow-hidden" data-id="element-253" data-mp="2oqfw258r2qhm">
          <div className="overflow-x-auto" data-id="element-254" data-mp="2srhoa24922a3">
            <table className="w-full min-w-[640px] text-left border-collapse" data-id="element-255" data-mp="2ssaxd9qol3ve">
              <caption className="sr-only" data-id="element-256" data-mp="tlydzbmgma2v">
                Representative California mesothelioma and asbestos case results
                by recovery amount, case type, location, and source of exposure.
              </caption>
              <thead data-id="element-257" data-mp="12gmfqrstt9mx">
                <tr className="bg-brand-900 text-white" data-id="element-258" data-mp="12gw82m1cfsvs">
                  <th scope="col" className="px-6 py-4 text-sm font-bold tracking-wide" data-id="element-259" data-mp="xna2fdtlkp9h">
                    Result
                  </th>
                  <th scope="col" className="px-6 py-4 text-sm font-bold tracking-wide" data-id="element-260" data-mp="17d36zuvbo448">
                    Case Type
                  </th>
                  <th scope="col" className="px-6 py-4 text-sm font-bold tracking-wide" data-id="element-261" data-mp="1hdna732ejip3">
                    Location
                  </th>
                  <th scope="col" className="px-6 py-4 text-sm font-bold tracking-wide" data-id="element-262" data-mp="3j50d5mkt7gii">
                    Exposure
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-200" data-id="element-263" data-mp="3d36k2fp58u51">
                {caseResults.map(result => <tr key={`${result.amount}-${result.location}`} className="hover:bg-brand-50 transition-colors" data-id="element-264" data-mp="3491vy41e9wt7">
                    <th scope="row" className="px-6 py-5 font-serif text-2xl font-bold text-brand-900 whitespace-nowrap text-left" data-id="element-265" data-mp="2pdvqbi67o00e">
                      {result.amount}
                    </th>
                    <td className="px-6 py-5 text-slate-700 font-medium" data-id="element-266" data-mp="2lb7fj4xxsj0s">
                      {result.caseType}
                    </td>
                    <td className="px-6 py-5 text-slate-700" data-id="element-267" data-mp="ehn6udlam1dh">
                      {result.location}
                    </td>
                    <td className="px-6 py-5 text-slate-700" data-id="element-268" data-mp="2flxtpytg6j0q">
                      {result.exposure}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>

        <div className="mt-8 flex flex-col sm:flex-row sm:items-center justify-between gap-6 bg-white border border-slate-200 rounded-xl p-8" data-id="element-269" data-mp="25mqgrcqmkqe5">
          <p className="text-slate-700 max-w-2xl" data-id="element-270" data-mp="21oiww90v78yq">
            <strong className="text-brand-900 font-semibold" data-id="element-271" data-mp="1wo4y7hl5lbdd">
              Wondering what your claim may be worth?
            </strong>{' '}
            Every case is valued on its own facts — diagnosis, exposure history,
            and the companies responsible. We will review yours at no cost.
          </p>
          <a href="tel:805-770-9317" className="inline-flex justify-center items-center gap-2 bg-brand-accent hover:bg-brand-accentHover text-brand-900 px-6 py-3 rounded-md font-bold transition-colors shrink-0" data-id="element-272" data-mp="1hzi6shi94t5s">
            <Phone className="w-4 h-4" data-id="element-273" data-mp="3kkumuxbgzx7y" />
            (805) 770-9317
          </a>
        </div>

        <p className="mt-6 text-sm text-slate-500 italic" data-id="element-274" data-mp="3pjxijr5k8r39">
          *Past results do not guarantee, warrant, or predict future cases.
          Every case is unique and must be judged on its own merits.
        </p>
      </div>
    </section>;
}